import { render, staticRenderFns } from "./ConfigList.vue?vue&type=template&id=68cf4fc8&"
import script from "./ConfigList.vue?vue&type=script&lang=js&"
export * from "./ConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68cf4fc8')) {
      api.createRecord('68cf4fc8', component.options)
    } else {
      api.reload('68cf4fc8', component.options)
    }
    module.hot.accept("./ConfigList.vue?vue&type=template&id=68cf4fc8&", function () {
      api.rerender('68cf4fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/ConfigList.vue"
export default component.exports